import { Grid, Paragraph } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const SortFiltersWrapper = styled.div`
    display: flex;
    align-items: space-between;
    margin-top: ${getPurpurSpacing('200')};
    gap: ${getPurpurSpacing('100')};

    ${purpurMedia('lg')`
        margin-top: 0;
        gap: ${getPurpurSpacing('200')};
        margin-left: auto;
    `};
`;

export const DrawerButtonContainer = styled.div`
    max-width: 7rem;
    ${purpurMedia('md')`
        max-width: initial;
        flex: 1;
    `};

    ${purpurMedia('lg')`
        display: none;
    `};
`;

export const SortSelectContainer = styled.div`
    flex: 1;

    ${purpurMedia('lg')`
        flex: auto;
    `};
`;

type IsFallbackProps = {
    $isFallback?: boolean;
};

export const ProductsAndFacetsContainer = styled.div<IsFallbackProps>`
    display: grid;
    grid-template-columns: 1.5fr;
    gap: ${getPurpurSpacing('300')};
    margin-top: ${getPurpurSpacing('250')};

    ${purpurMedia('md')`
        margin-top: ${getPurpurSpacing('300')};
    `};

    ${({ $isFallback }) => purpurMedia('lg')`
        grid-template-columns: ${$isFallback ? '1.5fr' : '19.875rem 1.5fr'};
        margin-top: ${getPurpurSpacing('400')};
    `}
`;

export const PageTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${purpurMedia('lg')`
        flex-direction: row;
        align-items: center;
    `}
`;

export const PageGrid = styled(Grid)`
    display: block;
    padding-top: 1.563rem;
    padding-bottom: 0;

    ${purpurMedia('md')`
        padding-bottom: ${getPurpurSpacing('800')};
    `}
`;

export const FacetsContainer = styled.div`
    display: none;

    ${purpurMedia('lg')`
        display: block;
    `}
`;

export const SelectedFiltersContainer = styled.div`
    margin-top: ${getPurpurSpacing('100')};
    ${purpurMedia('md')`
        margin-top: ${getPurpurSpacing('200')};
    `};
    ${purpurMedia('lg')`
        margin-top: ${getPurpurSpacing('400')};
    `};
`;

export const VatPricesNote = styled(Paragraph)`
    text-align: right;
`;

export const DescriptionWithContentSlotContainer = styled.div`
    padding-bottom: ${getPurpurSpacing('200')};
`;
